import { render, staticRenderFns } from "./labSpecies_page.vue?vue&type=template&id=3833d0e8&scoped=true"
import script from "./labSpecies_page.vue?vue&type=script&lang=js"
export * from "./labSpecies_page.vue?vue&type=script&lang=js"
import style0 from "./labSpecies_page.vue?vue&type=style&index=0&id=3833d0e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833d0e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3833d0e8')) {
      api.createRecord('3833d0e8', component.options)
    } else {
      api.reload('3833d0e8', component.options)
    }
    module.hot.accept("./labSpecies_page.vue?vue&type=template&id=3833d0e8&scoped=true", function () {
      api.rerender('3833d0e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/labSpecies_page.vue"
export default component.exports